module.exports = __webpack_public_path__ + "img/bsxq.de4f3456.png";